import { useEffect, useState } from 'react';
import { getWhitelabelClient } from '../../api/whitelabel';

export default function useWhitelabelClient(domain) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      const clientRes = await getWhitelabelClient(domain);
      setClient(clientRes);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const forceRefresh = () => {
    fetchData();
  };

  useEffect(() => {
    if (!domain) return;
    fetchData();
  }, [domain]);

  return { client, loading, error, forceRefresh };
}
